<template>
  <Breadcrumbs
      title="Edit User Role"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Users Roles', path: '/user-roles' },
      { label: 'Edit User Role', path: `/user-role-edit/${roleId}` },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <editUserRoleForm/>
    </div>
  </div>
</template>

<script>
import editUserRoleForm from './editUserRoleForm.vue';

export default {
  components: {
    editUserRoleForm
  },
  data() {
    return {
      roleId: this.$route.params.id  // get role id from route
    }
  }
}
</script>
